import { Survey } from "../models/survey.model";
import { UuidAndId } from "../models/uuid-and-id";
import { SurveyStateModel } from "../state/survey.state";

export namespace SurveyActions {
    export class Refresh {
        static readonly type = '[API-SURVEY] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-SURVEY] Increment Pending Count'
        constructor() {}
    } 
    export class Init {
        static readonly type = '[Storage-SURVEY] Init'
        constructor(public payload: SurveyStateModel) {}
    }
    export class Set {
        static readonly type = '[API-SURVEY] Set'
        constructor(public payload: Survey[]) {}
    }
    export class Merge {
        static readonly type = '[API-SURVEY] Merge'
        constructor(public payload: Survey[]) {}
    }
    export class AddOne {
        static readonly type = '[UI-SURVEY] Add One'
        constructor(public payload: Survey) {}
    }    
    export class UpdateOne {
        static readonly type = '[UI-SURVEY] Update One'
        constructor(public payload: Survey) {}
    }       
    export class DeleteOne {
        static readonly type = '[UI-SURVEY] Delete One'
        constructor(public payload: Survey) {}
    }     
    export class ApiAddedOne {
        static readonly type = '[API-SURVEY] Added One'
        constructor(public payload: Survey) {}
    }
    export class ApiUpdatedOne {
        static readonly type = '[API-SURVEY] Updated One'
        constructor(public payload: Survey) {}
    }
    export class ApiDeletedOne {
        static readonly type = '[API-SURVEY] Deleted One'
        constructor(public payload: UuidAndId) {}
    }     
}
